import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Draft: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[24px] h-[24px] stroke-[2px]', className)}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.12822 3.96154C6.8052 3.96154 6.49541 4.08986 6.267 4.31827C6.03859 4.54668 5.91027 4.85647 5.91027 5.17949V18.8205C5.91027 19.1435 6.03859 19.4533 6.267 19.6817C6.49541 19.9101 6.8052 20.0385 7.12822 20.0385H16.8718C17.1948 20.0385 17.5046 19.9101 17.733 19.6817C17.9614 19.4533 18.0898 19.1435 18.0898 18.8205V8.83333H14.9231C14.4709 8.83333 14.0372 8.65369 13.7174 8.33391C13.3976 8.01414 13.218 7.58043 13.218 7.12821V3.96154H7.12822ZM14.6795 4.995L17.0563 7.37179H14.9231C14.8585 7.37179 14.7965 7.34613 14.7508 7.30045C14.7052 7.25477 14.6795 7.19281 14.6795 7.12821V4.995ZM5.23353 3.2848C5.73604 2.7823 6.41757 2.5 7.12822 2.5H13.9487C14.1425 2.5 14.3284 2.57699 14.4655 2.71404L19.3373 7.58583C19.4743 7.72288 19.5513 7.90875 19.5513 8.10256V18.8205C19.5513 19.5312 19.269 20.2127 18.7665 20.7152C18.264 21.2177 17.5825 21.5 16.8718 21.5H7.12822C6.41757 21.5 5.73604 21.2177 5.23353 20.7152C4.73103 20.2127 4.44873 19.5312 4.44873 18.8205V5.17949C4.44873 4.46884 4.73103 3.7873 5.23353 3.2848Z"
      fill="currentColor"
      strokeWidth="currentStrokWidth"
    />
  </svg>
);

export default Draft;
